import { render, staticRenderFns } from "./ModalWithTitle.vue?vue&type=template&id=4be6b43f&scoped=true&"
import script from "./ModalWithTitle.vue?vue&type=script&lang=js&"
export * from "./ModalWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithTitle.vue?vue&type=style&index=0&id=4be6b43f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be6b43f",
  null
  
)

export default component.exports